module.exports = "/_next/static/images/napre_pizza-f30e408810d85010911b251ab087eb93.jpg";